import { Tooltip, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { RequireNonAggregationRow } from "components/strategyDashboard/heats/RequireNonAggregationRow";
import { HeatSeries } from "src/store/api/generatedApi";
import { TFunction } from "i18next";

const NonComplianceReasonCell = ({
  visibleUnavailableMaterials,
  t,
}: {
  visibleUnavailableMaterials: string[];
  t: TFunction;
}) => {
  if (visibleUnavailableMaterials.length === 0) return null;
  return (
    <Tooltip title={t("reasonUnavailableTooltip")} arrow>
      <Typography variant="body2" sx={{ fontStyle: "italic" }}>
        {t("reasonUnavailable", {
          materials: visibleUnavailableMaterials.join(", "),
        })}
      </Typography>
    </Tooltip>
  );
};

export const createNonComplianceReasonColumn = (
  t: TFunction,
  ignoredMaterials: Set<string>
): GridColDef<HeatSeries> => ({
  field: "unavailable_required_materials",
  headerName: t("nonComplianceReason"),
  width: 220,
  sortable: false,
  renderCell: RequireNonAggregationRow(({ row }) => {
    const materials = row.unavailable_required_materials;
    if (materials == null) return null;
    const visible = materials.filter((m) => !ignoredMaterials.has(m));
    return (
      <NonComplianceReasonCell visibleUnavailableMaterials={visible} t={t} />
    );
  }),
});
